@if (pickedPlayer === undefined && !gameEnds) {
  <div class="carousel-wrapper">
    <div
      class="player-image-background"
      [style.background-image]="'url(' + ('games/pitch-background.svg' | contentAssetImage) + ')'"
    ></div>
    <div *ngIf="gameDetails?.Players?.length > 0" id="players-carousel">
      <owl-carousel-o #owlCarousel [options]="customOptions" (translated)="onTranslated($event)">
        <ng-container *ngFor="let player of gameDetails.Players">
          <ng-template carouselSlide [id]="player.PlayerId.toString()">
            <div class="player-slide">
              <ng-container *ngIf="player.Image; else noImage">
                <img src="{{ player.Image | contentImage: '7' }}" alt="" />
              </ng-container>
              <ng-template #noImage>
                <img [src]="'placeholders/placeholderplayer.svg' | contentAssetImage" alt="" />
              </ng-template>
            </div>
          </ng-template>
        </ng-container>
      </owl-carousel-o>
    </div>

    <div class="action-container w-100 d-flex flex-column align-items-center">
      <p class="for-text font-size-12 fw-bold text-uppercase text-white">
        {{ gameDetails?.Players[this.currentCenterIndex]?.Position }}
      </p>

      <div class="change-player-container d-flex align-items-center justify-content-between">
        <button class="nav-btn bg-primary" (click)="prev()">
          <span class="material-symbols-outlined"> arrow_back </span>
        </button>
        <p class="font-size-18 fw-bold text-capitalize mb-0 text-white">
          {{ gameDetails?.Players[this.currentCenterIndex].PlayerName }}
        </p>
        <button class="nav-btn bg-primary" (click)="next()">
          <span class="material-symbols-outlined"> arrow_forward </span>
        </button>
      </div>

      <button class="pick-player-btn bg-primary" (click)="pickPlayer()">{{ 'fantasy.select.player.pick' | translate }}</button>
    </div>
  </div>
} @else {
  <div class="carousel-wrapper d-flex flex-row align-items-center flex-column">
    <div
      class="player-image-background"
      [style.background-image]="'url(' + ('games/pitch-background.svg' | contentAssetImage) + ')'"
    ></div>

    <div class="selected-player-container">
      <ng-container *ngIf="pickedPlayer?.Image; else noImage">
        <img src="{{ pickedPlayer.Image | contentImage: '7' }}" alt="" />
      </ng-container>
      <ng-template #noImage>
        <img [src]="'placeholders/placeholderplayer.svg' | contentAssetImage" alt="" />
      </ng-template>
    </div>

    <div class="action-container w-100 d-flex flex-column align-items-center">
      <p class="pick-text font-size-12 fw-bold text-capitalize text-white">{{ 'fantasy.select.player.your.pick' | translate }}</p>

      <p class="player-name font-size-18 fw-bold text-capitalize mb-0 w-100 text-center text-white">
        {{ pickedPlayer?.PlayerName }}
      </p>

      <button *ngIf="!gameEnds" class="pick-player-btn bg-quaternary text-black" (click)="editPick()">
        {{ 'fantasy.select.player.edit' | translate }}
      </button>
    </div>
  </div>
}
